import * as types from "../constants/ActionTypes";

export const hideLoadingValue = () => ({ type: types.HIDE_LOADING });
export const showLoadingValue = () => ({ type: types.SHOW_LOADING });

export const setConfirmInfoValue = (data) => ({ type: types.SET_CONFIRMINFO, data });

export const setAssessmentResultValue = () => ({ type: types.SET_ASSESSMENT_RESULT });

export const setUsernameOfResetPassword = (data) => ({ type: types.SET_USERNAME_OF_RESET_PASSWORD, data });